import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("column2", component(opts));
  editor.BlockManager.add("column2", block(opts));
};